export const services = {
  headers: {
    requestedService: "Zamówiona usługa",
  },
  actions: {
    discardRequest: "Odrzuć zgłoszenie",
  },
  storeInactiveTitle: "Sklep z usługami nie jest aktywny",
  storeInactiveDesc1:
    "Aby otrzymywać zgłoszenia na atrakcje i usługi dodatkowe, należy aktywować sklep.",
  storeInactiveDesc2:
    "Po aktywacji Państwa goście będą mogli zamawiać usługi bezpośrednio z WhatsApp.",
  activateStoreBtn: "Aktywuj sklep z usługami",

  noServicesDesc1:
    "Uruchom Atrakcje, konfigurując usługi dodatkowe: śniadanie, wycieczki, transfery lub cokolwiek innego z Państwa oferty.",
  noServicesDesc2:
    "Państwa goście zobaczą je zaraz po check-inie, bezpośrednio w WhatsApp.",
  addFirstServiceBtn: "Dodaj pierwszą atrakcję lub usługę",
};
